import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { HomeStoreContext } from '../contexts/StoreContext'
import { HomeStore } from '../store/interface'

export const useHomeStore: UseStore<HomeStore> = selector => {
  return useContextStore(HomeStoreContext, selector)
}

export const useHomeStoreApi = () => {
  return useContextStoreApi(HomeStoreContext)
}
